import { useContext, useMemo } from "react";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
const useQueryFieldTypes = () => {
  const fieldTypes = useContext(FieldTypesContext);
  return useMemo(() => fieldTypes.currentQuery, [fieldTypes.currentQuery]);
};
export default useQueryFieldTypes;
